module.exports = __webpack_public_path__ + "img/02_full.8b5ac6b7.jpg";